import { render, staticRenderFns } from "./Terceros.vue?vue&type=template&id=73459ed1&"
import script from "./Terceros.vue?vue&type=script&lang=js&"
export * from "./Terceros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports